import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, OnInit, ViewEncapsulation } from '@angular/core';
import { License } from '@portal-core/licenses/models/license.model';
import { LicensesService } from '@portal-core/licenses/services/licenses.service';
import { AutoUnsubscribe } from '@portal-core/util/auto-unsubscribe.decorator';
import { of, Subscription, switchMap } from 'rxjs';

@Component({
  selector: 'mc-auth-card-header',
  templateUrl: './auth-card-header.component.html',
  styleUrls: ['./auth-card-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
@AutoUnsubscribe()
export class AuthCardHeaderComponent implements OnInit {
  /** Applies the mc-auth-card-header class to the host element. */
  @HostBinding('class.mc-auth-card-header') hostClass: boolean = true;

  license: License;
  licenseSubscription: Subscription;
  loaded: boolean = false;

  constructor(private cdr: ChangeDetectorRef, private licensesService: LicensesService) { }

  ngOnInit() {
    this.licenseSubscription = this.licensesService.getLicenseByDomain$().pipe(
      switchMap(license => typeof license?.Id === 'number' ? this.licensesService.getItemById$(license?.Id, { allowApiRequest: false }) : of(null))
    ).subscribe(license => {
      this.license = license;
      this.loaded = true;
      this.cdr.markForCheck();
    }, () => {
      this.loaded = true;
      this.cdr.markForCheck();
    });
  }
}
